<ng-container *ngIf="queryFilters?.q as queryValue">
  <section class="query-filter-section mt-4">
    <p class="mb-4">
      Query filter <code>{{ queryValue }}</code> is currently applied.
    </p>
  </section>
</ng-container>
<div *ngIf="!filterRows.length" class="filter-row-empty flex flex-col gt-xs:flex-row">
  <div class="filter-row-empty__body">
    <mat-icon>filter_list</mat-icon>
    <span>No filters selected</span>
  </div>
</div>
<div class="filter-row" *ngFor="let filter of filterRows; let i = index">
  <div class="filter-row-fields flex flex-col gt-xs:flex-row">
    <!-- FIELD NAME -->
    <mat-form-field class="flex-auto gt-xs:pr-2">
      <mat-label>Field Name</mat-label>
      <mat-select
        [disabled]="readonly"
        *ngIf="!allowRelatedObjectFields; else groupedFields"
        (selectionChange)="relayFilterFieldSelected($event, filter)"
        [(value)]="filter.field"
        (openedChange)="fieldSelectionOpenedChange()"
      >
        <mat-form-field class="sticky top-0 z-10 w-full p-2 pb-0 search-field">
          <input
            [formControl]="searchField"
            matInput
            placeholder="Search..."
            autocomplete="off"
            (keydown)="$event.stopPropagation()"
          />
        </mat-form-field>
        <mat-option
          *ngFor="let field of newFilterFields | sort: 'asc' : 'name'"
          [value]="field"
          [class.display-none]="field.name?.toLowerCase().indexOf(searchField.value.toLowerCase()) === -1"
        >
          {{ field.name }}
        </mat-option>
      </mat-select>
      <ng-template #groupedFields>
        <mat-select
          [disabled]="readonly"
          (selectionChange)="relayFilterFieldSelected($event, filter)"
          [(value)]="filter.field"
          (openedChange)="fieldSelectionOpenedChange()"
        >
          <mat-form-field class="sticky top-0 z-10 w-full p-2 pb-0 bg-white">
            <input
              [formControl]="searchField"
              matInput
              placeholder="Search..."
              autocomplete="off"
              (keydown)="$event.stopPropagation()"
            />
          </mat-form-field>
          <mat-optgroup
            *ngFor="let group of newFilterFields | groupBy: 'group_by' : 'group_label'"
            [label]="group.groupLabel | relatedToTypeTitle: []"
            [disabled]="false"
            [class.display-none]="
              (searchField.valueChanges | async | mutateToAny: hasSearchMatchInGroup : group.items) === false
            "
          >
            <mat-option
              *ngFor="let item of group.items"
              [value]="item"
              [class.display-none]="
                item.exclude_in_nested_filter ||
                item.name?.toLowerCase().indexOf(searchField.value.toLowerCase()) === -1
              "
            >
              {{ item.name }}
            </mat-option>
          </mat-optgroup>
        </mat-select>
      </ng-template>
    </mat-form-field>

    <!-- FILTER -->
    <mat-form-field class="flex-auto gt-xs:pr-2">
      <mat-label>Filter</mat-label>
      <mat-select
        (selectionChange)="operatorChanged()"
        [disabled]="readonly || filter.type === ''"
        [(value)]="filter.filter"
      >
        <mat-option *ngFor="let stringFilter of filter?.field?.operators" [value]="stringFilter">
          {{ stringFilter | operatorToDisplayString }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- VALUES -->
    <mat-form-field
      class="flex-auto gt-xs:pr-0"
      *ngIf="
        filter.type === 'string' ||
        filter.type === 'number' ||
        filter.type === 'decimal' ||
        filter.type === 'percent' ||
        filter.type === 'money' ||
        filter.type === 'text' ||
        filter.type === 'year' ||
        filter.type === ''
      "
    >
      <mat-label>
        Value
        @if (!isFilterRowValid(filter)) {
          <span> (required)</span>
        }
      </mat-label>
      <input
        [(value)]="filter.value"
        [disabled]="filter.type === '' || readonly"
        matInput
        [autocomplete]="'off'"
        [placeholder]="'Value'"
        (input)="relayFilterValueChange($event.target.value, filter)"
        (blur)="relayFilterValueChange($event.target.value, filter, {}, true)"
      />
    </mat-form-field>

    <mat-form-field class="flex-auto gt-xs:pr-0" *ngIf="filter.type === 'record'">
      <mat-label>
        Value
        @if (!isFilterRowValid(filter)) {
          <span> (required)</span>
        }
      </mat-label>
      <input
        matInput
        #trigger="matAutocompleteTrigger"
        [disabled]="readonly"
        [placeholder]="filter.name"
        [matAutocomplete]="matAutocompleteRecord"
        [spellcheck]="false"
        [(value)]="filter.value"
        (input)="relayOnRecordSearchChange(trigger, $event.target.value, filter)"
      />
    </mat-form-field>
    <mat-autocomplete
      #matAutocompleteRecord="matAutocomplete"
      [disableRipple]="true"
      (optionSelected)="relayAutocompleteRecord($event, filter)"
    >
      <mat-option *ngFor="let record of recordResults" [value]="record">
        {{ getRecordName(record) }}
      </mat-option>
    </mat-autocomplete>

    <mat-form-field class="flex-auto gt-xs:pr-0" *ngIf="filter.type === 'typeahead'">
      <mat-label>
        Value
        @if (!isFilterRowValid(filter)) {
          <span> (required)</span>
        }
      </mat-label>
      <input
        matInput
        [placeholder]="filter.name"
        [matAutocomplete]="matAutocompleteTypeahead"
        [spellcheck]="false"
        [disabled]="readonly"
        [(value)]="filter.value"
        (input)="onTypeaheadChange($event.target.value, filter)"
      />
    </mat-form-field>
    <mat-autocomplete
      #matAutocompleteTypeahead
      [disableRipple]="true"
      (optionSelected)="relayAutocompleteRecord($event, filter)"
    >
      <mat-option class="no-results" *ngIf="typeaheadResults && !typeaheadResults.length"> No results!</mat-option>

      <mat-option *ngFor="let result of typeaheadResults" [value]="result">
        {{ result }}
      </mat-option>
    </mat-autocomplete>

    <mat-form-field
      class="flex-auto gt-xs:pr-0"
      *ngIf="(filter.type === 'date' || filter.type === 'datetime') && filter.filter !== 'is'"
    >
      <mat-label>
        Value
        @if (!isFilterRowValid(filter)) {
          <span> (required)</span>
        }
      </mat-label>
      <input
        [disabled]="readonly"
        [(value)]="filter.value"
        (dateInput)="relayFilterValueChange($event.target.value, filter)"
        matInput
        [matDatepicker]="createdAtGteqPicker"
        [placeholder]="'Date'"
        readonly
      />
      <mat-datepicker-toggle matSuffix [for]="createdAtGteqPicker"></mat-datepicker-toggle>
      <mat-datepicker #createdAtGteqPicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field
      class="flex-auto gt-xs:pr-0"
      *ngIf="(filter.type === 'date' || filter.type === 'datetime') && filter.filter === 'is'"
    >
      <mat-label>
        Value
        @if (!isFilterRowValid(filter)) {
          <span> (required)</span>
        }
      </mat-label>
      <mat-select
        [disabled]="readonly"
        (selectionChange)="relayFilterValueChange($event, filter)"
        [(value)]="filter.value"
      >
        <mat-option *ngFor="let func of filter.field.functions" [value]="func">
          {{ func }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <ng-container *ngIf="filter.type === 'autocomplete'">
      <div style="position: relative" id="autocomplete-field-{{ i }}">
        <mat-form-field (click)="showAutocompleteOptions(i, filter)">
          <mat-label>
            Value
            @if (!isFilterRowValid(filter)) {
              <span> (required)</span>
            }
          </mat-label>
          <input
            [disabled]="readonly"
            [value]="getAutocompleteLabel(filter)"
            readonly="true"
            matInput
            [placeholder]="'Select a value'"
            (ngModelChange)="onAutocompleteSearch($event, filter)"
          />

          <button
            mat-button
            matSuffix
            mat-icon-button
            (click)="showAutocompleteOptions(i, filter)"
            #autocompleteOptionsPanelOrigin
          >
            <mat-icon>arrow_drop_down</mat-icon>
          </button>
        </mat-form-field>
        <div class="dropdown-autocomplete autocomplete-{{ i }}">
          <div class="autocomplete-filter-container__header">
            <div class="autocomplete-filter-container__header__filter">
              <mat-icon svgIcon="search"></mat-icon>
              <input
                autofocus
                type="text"
                placeholder="Search..."
                [(ngModel)]="filterText"
                (ngModelChange)="onAutocompleteSearch($event, filter)"
              />
            </div>
          </div>
          <ng-template #autocompleteLoading>
            <mat-progress-spinner class="spinner" diameter="24" mode="indeterminate"></mat-progress-spinner>
          </ng-template>
          <div
            class="autocomplete-filter-container__items"
            *ngIf="autocompleteSearchOpts[getRecordType(filter)] | async as opts; else autocompleteLoading"
          >
            <div class="autocomplete-filter-container__items__item" *ngFor="let item of opts">
              <mat-checkbox
                color="primary"
                [checked]="isAutocompleteItemChecked(filter, item)"
                (change)="relayFilterValueChange($event, filter, item)"
                [(value)]="filter.value"
              >
                {{ item.name || item.title || item.address_string }}
              </mat-checkbox>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <mat-form-field class="flex-auto gt-xs:pr-0" *ngIf="filter.type === 'multiple'">
      <mat-label>{{ filter.field.name }}</mat-label>
      <mat-select
        [disabled]="readonly"
        multiple
        (selectionChange)="relayFilterValueChange($event, filter)"
        [(value)]="filter.value"
      >
        <mat-option *ngFor="let option of filter.options" [value]="option.id">
          {{ option.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="flex-auto gt-xs:pr-0" *ngIf="filter.type === 'select'">
      <mat-label>{{ filter.field.name }}</mat-label>
      <mat-select
        [disabled]="readonly"
        multiple
        (selectionChange)="relayFilterValueChange($event, filter)"
        [(value)]="filter.value"
      >
        <mat-option *ngFor="let option of filter.options" [value]="option">
          {{ option }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="flex-auto gt-xs:pr-0" *ngIf="filter.type === 'checkbox'">
      <mat-label>{{ filter.field.name }}</mat-label>
      <mat-select
        [disabled]="readonly"
        multiple
        (selectionChange)="relayFilterValueChange($event, filter)"
        [(value)]="filter.value"
      >
        <mat-option [value]="true"> Yes</mat-option>
        <mat-option [value]="false"> No</mat-option>
      </mat-select>
    </mat-form-field>

    @if (!readonly) {
      <button
        class="list-filter-item-remove"
        type="button"
        mat-icon-button
        matTooltip="Remove"
        (click)="relayRemoveFilter(i)"
      >
        <mat-icon [svgIcon]="'cancel'"></mat-icon>
      </button>
    }
  </div>
</div>
<div class="filter-row-fields flex flex-col gt-xs:flex-row mx-1 mb-3" *ngIf="!!filterRows.length && allowKeyDates">
  <mat-checkbox
    [checked]="queryFilters?.filterOptions?.include_keydates"
    [color]="'primary'"
    (change)="
      relayFilterValueChange($event, { id: 'include_keydates' }, { id: 'include_keydates', name: 'include_keydates' })
    "
  >
    <span>Include KeyDates</span>
  </mat-checkbox>
</div>
